module.exports = __webpack_public_path__ + "media/src/images/invoice-03-14cef5e3f55bf3922db51fda93808bfd.png";